import classes from './SidebarSummary.module.scss';
import VerifiedLogo from '../../../../images/verified.svg';
import IconButton, { NoStyleButton } from '../../../common/icon-button/IconButton';
import { useSelector } from 'react-redux';
import FlexBetweenItem from '../../../common/layout/FlexBetweenItem';
import VerticalStack from '../../../common/wrapper/VerticalStack';
import { AppText, AppTitle } from '../../../common/typography/app-text';
import { ReactComponent as Payl8rLogo } from '../../../../images/Payl8r-Logo-White 1.svg';
import AppAvatar from '../../../common/app-avatar/AppAvatar';
import { ReactComponent as StarIcon } from '../../../../images/star.svg';
import { ReactComponent as DeleteIcon } from '../../../../images/icons/bl-delete-icon.svg';
import { SendFinanceRequest } from '../../../redux/actions/pay-later/payLaterAction';
import { useState } from 'react';
import SuccessModal from '../../../../components/modal/SuccessModal/index';
import AppDivider from '../../../common/layout/AppDivider';
import { BOOKING_LINK_STEP } from '../constants';
import { pounds } from '../../../../utils/general';
import StepButton from '../../../common/StepButton';
import moment from 'moment';
import DiscountModal from '../DiscountModal';
import ActionModal from '../../../modal/ActionModal/ActionModal';
import { toastV2 } from '../../../common/CustomToast/toastV2';
import { formatTime } from '../helper';
import { webBaseUrl } from '../../../../config';
import { useParams } from 'react-router';
import CustomModal from '../../../modal/CustomModal';

const Header = ({ isVerified, title, isEdit, onEditClick }) => {
    return (
        <div className={classes.header}>
            <div className={classes.header__wrapper}>
                <p className={classes.header__clinicName}>{title}</p>
                {isVerified && (
                    <div className={classes.header__verified}>
                        <img src={VerifiedLogo} alt="verified" />
                        <p className={classes.header__verifiedText}>FACES VERIFIED</p>
                    </div>
                )}
            </div>
            {isEdit && (
                <NoStyleButton onClick={onEditClick} className={classes.header__edit}>
                    Edit
                </NoStyleButton>
            )}
        </div>
    );
};

function SidebarSummary({
    selectedLocation,
    step,
    setStep,
    callPayl8rApi,
    selectedTreatment,
    handleNextStep,
    isNextStepDisabled,
    formatedDate,
    selectedTimes,
    selectedTeamMember,
    isNextButtonLoading,
    totalPrice,
    clinicId,
    discountValue,
    grandTotal,
    shallRenderNextStepButton,
    handleRemoveDiscount,
    selectedPaymentOption,
    isEdit
}) {
    const { slug } = useParams();
    const [requestSendModal, setRequestSendModal] = useState(false);
    const [isDiscountOpen, setIsDiscountOpen] = useState(false);
    const [isRemoveDiscountOpen, setIsRemoveDiscountOpen] = useState(false);
    const [isConfirmationModel, setIsConfirmationModel] = useState(false);

    const { initiatesendFinance } = SendFinanceRequest();

    const { isVerified } = useSelector((state) => state?.verifiedBusinessBadgeReducer);
    const paylaterStatus = useSelector((state) => state.payLaterReducer.payLaterStatus);
    const clinic_id = useSelector((state) => state.businessLocationListReducer.clinic_id) || null;

    const sendRequestForPayl8r = () => {
        initiatesendFinance(
            {
                clinicId: parseInt(clinic_id),
                requestMail: false, //sending false because this flag is for user to turn on finance toggle but user is not registered yet
            },
            () => {
                setRequestSendModal(true);
            },
            () => {
                alert('Something went wrong!');
            }
        );
    };

    return (
        <div className={classes.sidebarSummary}>
            <VerticalStack>
                <div>
                    <Header
                        title={selectedLocation?.clinic_name}
                        isVerified={isVerified?.is_verified}
                        isEdit={isEdit}
                        onEditClick={() => {
                            // const clinicslug = encodeURIComponent(selectedClinicSlug?.clinic_slug);
                            // setStep(BOOKING_LINK_STEP.LOCATION);
                            setIsConfirmationModel(true)
                        }}
                    />
                    <FlexBetweenItem>
                        <VerticalStack space={10}>
                            <AppTitle>{selectedLocation?.clinic_name}</AppTitle>
                            {paylaterStatus === false ? (
                                <AppText>
                                    Offers buy now later via{' '}
                                    <span className={classes.payl8rLogo}>
                                        <Payl8rLogo />
                                    </span>
                                    <NoStyleButton
                                        onClick={callPayl8rApi}
                                        className={classes.learnMore}
                                    >
                                        learn more
                                    </NoStyleButton>
                                </AppText>
                            ) : (
                                <NoStyleButton
                                    onClick={sendRequestForPayl8r}
                                    className={classes.learnMore}
                                >
                                    Request buy now payl8r
                                </NoStyleButton>
                            )}
                            <AppText>{selectedLocation?.complete_address}</AppText>
                            <div className={classes.reviews}>
                                <StarIcon />
                                <p>
                                    {selectedLocation?.cln_average_rating} (
                                    {selectedLocation?.total_reviews})
                                </p>
                            </div>
                        </VerticalStack>
                        <AppAvatar
                            name={selectedLocation?.clinic_name}
                            src={selectedLocation?.image_url}
                        />
                    </FlexBetweenItem>
                </div>
                {selectedTreatment?.length > 0 && (
                    <div>
                        <Header
                            title={'Treatments'}
                            isEdit={step !== BOOKING_LINK_STEP.TREATMENT}
                            onEditClick={() => {
                                setStep(BOOKING_LINK_STEP.TREATMENT);
                            }}
                        />
                        <VerticalStack space={20}>
                            {selectedTreatment.map((item, index) => (
                                <div key={index}>
                                    <VerticalStack space={5}>
                                        <AppTitle>{item.name}</AppTitle>
                                        <AppText>
                                            {pounds.format(item?.amount)} • {formatTime(item?.duration)}
                                        </AppText>
                                    </VerticalStack>
                                </div>
                            ))}
                            <AppDivider />
                            <FlexBetweenItem>
                                <AppTitle>Total </AppTitle>
                                <AppTitle>{pounds.format(totalPrice)}</AppTitle>
                            </FlexBetweenItem>
                        </VerticalStack>
                    </div>
                )}
                {formatedDate != null && step > BOOKING_LINK_STEP.TREATMENT && (
                    <div>
                        <Header
                            title={'Appointment details'}
                            isEdit={step !== BOOKING_LINK_STEP.DATE_AND_TIME}
                            onEditClick={() => {
                                setStep(BOOKING_LINK_STEP.DATE_AND_TIME);
                            }}
                        />
                        <VerticalStack space={20}>
                            <div>
                                <VerticalStack space={5}>
                                    <AppTitle>Date</AppTitle>
                                    <AppText>
                                        {moment(formatedDate, 'Do MMMM YYYY').format('Do MMM YYYY')}
                                    </AppText>
                                </VerticalStack>
                            </div>
                            {selectedTimes && (
                                <div>
                                    <VerticalStack space={5}>
                                        <AppTitle>Time</AppTitle>
                                        <AppText>{selectedTimes}</AppText>
                                    </VerticalStack>
                                </div>
                            )}
                        </VerticalStack>
                    </div>
                )}
                {selectedTeamMember && step > BOOKING_LINK_STEP.DATE_AND_TIME && (
                    <div>
                        <Header
                            title={'Team member'}
                            isEdit={step !== BOOKING_LINK_STEP.TEAM_MEMBER}
                            onEditClick={() => {
                                setStep(BOOKING_LINK_STEP.TEAM_MEMBER);
                            }}
                        />
                        <VerticalStack space={20}>
                            <FlexBetweenItem>
                                <VerticalStack space={5}>
                                    <AppTitle>{selectedTeamMember?.name}</AppTitle>
                                    <AppText>{selectedTeamMember?.occupations.join(', ')}</AppText>
                                </VerticalStack>
                                <AppAvatar
                                    name={selectedTeamMember?.name}
                                    src={selectedTeamMember?.image}
                                />
                            </FlexBetweenItem>
                        </VerticalStack>
                    </div>
                )}
                {selectedTreatment.length !== 0 && (
                    <div>
                        <Header title="Payment summary" />
                        <VerticalStack space={20}>
                            {selectedTreatment.map((item, index) => (
                                <FlexBetweenItem key={index}>
                                    <AppText dark>{item.name}</AppText>
                                    <AppText dark>{pounds.format(item?.amount)}</AppText>
                                </FlexBetweenItem>
                            ))}
                            <FlexBetweenItem>
                                <AppText dark>Subtotal</AppText>
                                <AppText dark>{pounds.format(totalPrice)}</AppText>
                            </FlexBetweenItem>
                            <FlexBetweenItem>
                                <AppText
                                    onClick={() => {
                                        if(!selectedPaymentOption) {
                                            toastV2('You can apply the discount after selecting the payment method');
                                        }
                                        else if (discountValue === 0) {
                                            setIsDiscountOpen(true);
                                        }
                                    }}
                                    dark
                                    className={
                                        discountValue === 0 &&
                                        'text-decoration-underline cursor-pointer'
                                    }
                                >
                                    {discountValue === 0 ? 'Apply discount' : 'Applied discount'}
                                </AppText>
                                {/* todo: add discount dynamic price */}
                                <div className={classes.discountPriceWrapper}>
                                    <AppText dark>{pounds.format(discountValue)}</AppText>
                                    {discountValue > 0 && (
                                        <IconButton onClick={() => setIsRemoveDiscountOpen(true)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                </div>
                            </FlexBetweenItem>
                            <FlexBetweenItem>
                                <AppTitle>Order total</AppTitle>
                                {/* todo: add order total dynamic price */}
                                <AppTitle>{pounds.format(grandTotal)}</AppTitle>
                            </FlexBetweenItem>
                        </VerticalStack>
                    </div>
                )}
                {shallRenderNextStepButton && (
                    <StepButton
                        label="Continue"
                        blue
                        disabled={isNextStepDisabled()}
                        onClick={() => {
                            handleNextStep();
                        }}
                        isLoading={isNextButtonLoading}
                    />
                )}
            </VerticalStack>
            <SuccessModal
                isOpen={requestSendModal}
                setIsOpen={setRequestSendModal}
                title={''}
                subTitle={
                    "We've let the practitioner know you are interested in Buy Now Pay Later "
                }
            />
            <DiscountModal
                isOpen={isDiscountOpen}
                setIsOpen={setIsDiscountOpen}
                clinicId={clinicId}
            />
            <ActionModal
                title='Are you sure'
                desc='you want to delete this discount code?'
                onlyAction
                onAction={() => {
                    handleRemoveDiscount();
                    setIsRemoveDiscountOpen(false);
                }}
                actionText='Ok'
                onClose={() => setIsRemoveDiscountOpen(false)}
                open={isRemoveDiscountOpen}
            />

            <CustomModal
                modalOpen={isConfirmationModel}
                setModalOpen={setIsConfirmationModel}
                modaltitle={"Are you sure?"}
                className={'customConfimationModel'}
                modelDescShow={true}
                modelDesc={'You may lose the selected treatment. Do you want to proceed?'}
                modalBody={
                    <div className='btnWrapper'>
                        <StepButton className='blueBtn' label={'Yes'} onClick={() => {
                           window.location.href = `${webBaseUrl}/bookings/${slug}`;
                            setIsConfirmationModel(false)
                        }} />
                        <StepButton className='greyBtn' label={'No'} onClick={() => {
                            setIsConfirmationModel(false)
                        }} />
                    </div>
                }
            />
        </div>
    );
}
export default SidebarSummary;
